module.exports = __webpack_public_path__ + "static/media/174d458a-81e0-4174-9473-35e3bf0a613c.50fe0240.woff2";